<template>
    <div class="button outlined blockButton" @click="showModal()">ブロック解除</div>
    <div class="form" v-if="show">
        <div class="box" v-click-outside="closeModal">
            <div ref="slider" class="contents keen-slider">
                <div class="confirm">
                    <h3>
                      選択したアカウントの<br>
                      ブロックを解除しますか？
                    </h3>
                    <div class="next">
                        <div class="button" :class="{ 'disabled': isDisabled }" @click="next()">ブロック解除</div>
                        <div class="button outlined" @click="closeModal">キャンセル</div>
                    </div>
                </div>
                <div class="complete">
                    <div class="icon"></div>
                    <h3>ブロックを解除しました</h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3'
import KeenSlider from 'keen-slider';
export default {
    props: {
        user: Object
    },
    data() {
        return {
            params: {
              user_id: null
            },
            show: false,
            slide: null,
            index: 0,
            isDisabled: false
        }
    },
    mounted() {
        const content = document.querySelector('.accounts')
        if (content) {
            this.initSlide()
        }
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    methods: {
        showModal() {
            this.show = true;
        },
        closeModal() {
            this.show = false;
        },
        initSlide() {
            const sliderUl = this.$refs.slider
            if (!sliderUl) return
            const childrenArray = Array.from(sliderUl.children)
            this.slide = KeenSlider(this.$refs.slider, {
                initial: this.index,
                drag: false,
                slides: {
                    perView: 1
                },
                selector: childrenArray
            })
            this.slide.on('slideChanged', (instance) => {
                const current = instance.track.details.abs
                this.index = current
            })
        },
        async next() {
            await this.delete()
        },
        prev(number) {
            this.slide.prev('slideChanged', () => {
                this.index = number
            })
        },
        async delete(number) {
            this.isDisabled = true
            // アカウント削除API
                this.params.user_id = this.user.blocked_user_id;
                await axios.post('/api/users/account/unblock', this.params).then(res => {
                    if (res.data.success) {
                        this.slide.next('slideChanged', () => {
                            this.index = number
                            this.isDisabled = false
                        })
                        setTimeout(function() {
                            window.location.reload()
                        },2000);

                    } else {
                        console.log(res.data.errors)
                        this.errors = res.data.errors
                        this.isDisabled = false
                    }
                }).catch(e => {
                    console.log('Error', e)
                });
        }
    },
    watch: {
        show(val) {
            if (!val) return
            this.$nextTick(() => {
                this.initSlide(val)
            })
        }
    }
}
</script>
